import { AI_ACCOUNT_CHOICES, type AiAccountChoice, orList } from './ai-account-choices'

/**
 * The notice that says teammates run on the user's own AI account, so nobody expects a model to be included.
 * One source for every surface that shows it (the AI account step, the team proposal).
 */
export interface AiAccountNotice {
    /** Shown on the team proposal, which comes after the AI account step. */
    proposal: string
    /** Shown on the AI account step itself (#1933), where the account gets connected, so nothing says "next". */
    accountStep: string
}

/** The names of the choices of one kind, as running copy lists them. */
function named(kind: AiAccountChoice['kind']): string {
    return orList(AI_ACCOUNT_CHOICES.filter(choice => choice.kind === kind).map(choice => choice.name))
}

/**
 * #1717, F9 of #1697. It says "Every plan includes your COO", never that the COO is free.
 *
 * #2150: it names every way to bring an account, evenly and from the shared list of choices, the way the AI account
 * card's own intro does: a Claude, ChatGPT or SuperGrok plan, or an API key from Anthropic, OpenAI, xAI or
 * OpenRouter. Claude is one of the plans, never the only route.
 *
 * #1933 moved the notice off the sign-in screen and onto the AI account step. Its sign-up wording ended "You'll
 * connect it next", which is wrong on the step that connects it, so that variant is gone and the step says the
 * proposal wording.
 */
const NOTICE = `Every plan includes your COO. Your team runs on your own AI account: your ${named('plan')} plan, or an API key from ${named('key')}.`

export const AI_ACCOUNT_NOTICE: AiAccountNotice = {
    proposal: NOTICE,
    accountStep: NOTICE,
}
